var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas97(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon-24px-Diesel_Balance",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#c4cdeb}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    d: "M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    fill: "#2e4491",
    d: "M521.818 301.083v-4h-7l-4 6h-1v-2h1v-2h-5v2h1v2h-1v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-15zm-2 0h-5.258l1.333-2h3.931v2z",
    transform: "translate(-497.818 -291.083)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    d: "M531.45 346.868s-3.955 3.793-3.934 6.253a4.237 4.237 0 0 0 4.03 4.413h.008a4.259 4.259 0 0 0 3.961-4.5c-.021-2.46-4.065-6.166-4.065-6.166z",
    className: "cls-1",
    transform: "translate(-515.384 -334.669)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas97);
export default __webpack_public_path__ + "static/media/gas97.027e3957f8b945180ca495b5f97cc7e9.svg";
export { ForwardRef as ReactComponent };